import {
	WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED,
	WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED_SUCCESS,
	WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED_ERROR,
	WARRANTY_CLAIM_PAYMENTS_IMPORT,
	WARRANTY_CLAIM_PAYMENTS_IMPORT_SUCCESS,
	WARRANTY_CLAIM_PAYMENTS_IMPORT_ERROR,
} from "../actions/warrantyClaimPayments";
import WarrantyClaimPaymentsService from '@/services/warrantyClaimPayments';

const state = {
	status: '',
};

const getters = {
};

const actions = {
	[WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED]: ({ commit }, data) => {
		let requestData = {
			size: data.tableProps.itemsPerPage,
			page: data.tableProps.currentPage,
			sort: data.ctx.sortBy,
			desc: data.ctx.sortDesc,
		}
		if (data.tableProps.inputFilter.warrantyClaimId) {
			requestData.warrantyClaimIdFilter = data.tableProps.inputFilter.warrantyClaimId;
		}
		return new Promise((resolve, reject) => {
			commit(WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED);
			WarrantyClaimPaymentsService.listFiltered(requestData)
				.then(responseData => {
					commit(WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED_ERROR, error);
					reject(error);
				});
		});
	},
	[WARRANTY_CLAIM_PAYMENTS_IMPORT]: ({ commit }, formData) => {
		return new Promise((resolve, reject) => {
			commit(WARRANTY_CLAIM_PAYMENTS_IMPORT);
			WarrantyClaimPaymentsService.import(formData)
				.then(responseData => {
					commit(WARRANTY_CLAIM_PAYMENTS_IMPORT_SUCCESS, responseData);
					resolve(responseData);
				})
				.catch(error => {
					commit(WARRANTY_CLAIM_PAYMENTS_IMPORT_ERROR, error);
					reject(error);
				});
		});
	},
};

const mutations = {
	[WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED]: state => {
		state.status = 'loading';
	},
	[WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[WARRANTY_CLAIM_PAYMENTS_LIST_FILTERED_ERROR]: state => {
		state.status = 'error';
	},
	[WARRANTY_CLAIM_PAYMENTS_IMPORT]: state => {
		state.status = 'loading';
	},
	[WARRANTY_CLAIM_PAYMENTS_IMPORT_SUCCESS]: (state, responseData) => {
		state.status = 'success';
	},
	[WARRANTY_CLAIM_PAYMENTS_IMPORT_ERROR]: state => {
		state.status = 'error';
	},
};

export default {
	state,
	getters,
	actions,
	mutations
};